import type { PropsWithChildren } from 'react';
import React, { useState } from 'react';
import { useVyStepper } from '../../../hooks/use-vy-stepper';
import type { PlanInputForm } from '../../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { CREATE_PLAN_TABS } from '../../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import type { PlanCreateReason } from '../create-plan-context-types/plan-create-reason';
import type { PlanCreationStep } from '../create-plan-context-types/plan-creation-step';
import { PLAN_CREATION_STEPS } from '../create-plan-context-types/plan-creation-step';
import { CreatePlanContext } from '../index';
import { usePlanCreationFormUtils } from './hooks/use-plan-creation-form-utils';
import { usePlanCreationPlanPreview } from './hooks/use-plan-creation-plan-preview';

export type CreatePlanProviderProps<ExistingPlan extends PlanInputForm> = {
  planCreationReason: PlanCreateReason;
  defaultPlanCreationStep: PlanCreationStep;
  existingPlan?: ExistingPlan;
  onFinalStep?: () => void;
};

export function CreatePlanProvider<ExistingPlan extends PlanInputForm>({ children, planCreationReason, defaultPlanCreationStep, existingPlan, onFinalStep = () => {} }: PropsWithChildren<CreatePlanProviderProps<ExistingPlan>>) {
  const [currentTab, setCurrentTab] = useState<CreatePlanTab>(CREATE_PLAN_TABS.serviceFees);
  const planPreview = usePlanCreationPlanPreview();
  const formUtils = usePlanCreationFormUtils(existingPlan, planCreationReason);
  const planCreationStepper = useVyStepper(defaultPlanCreationStep, PLAN_CREATION_STEPS, onFinalStep);

  return (
    <CreatePlanContext.Provider value={{
      formUtils,
      planCreationStepper,
      planPreview,
      createPlanTab: currentTab,
      setCreatePlanTab: setCurrentTab,
    }}
    >
      {children}
    </CreatePlanContext.Provider>
  );
}